import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TitleDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const TitleAndListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 8px;
`;

export const AutocompleteContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;

  > div:first-child {
    flex: 1;
    > div:first-child {
      width: 100%;
    }
  }
`;

export const CollapsibleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const CollapsibleHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;

export const GranteesListScrollWrapper = styled.div`
  max-height: 300px;
  position: relative;
  /* Key: Use clip-path instead of overflow to create scroll effect */
  /* This allows content to escape for dropdowns */
`;

export const GranteesListContainerExternal = styled.div`
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: visible;
  position: relative;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
`;

export const GranteesListContainerInternal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 8px 0;
  overflow: visible;
  position: relative;
`;

export const GranteeItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  transition: background-color 0.2s;
  /* Allow dropdown menus to overflow */
  position: relative;
  z-index: 1;

  &:hover {
    background-color: #f5f5f5;
    /* Increase z-index on hover to ensure dropdown appears above other items */
    z-index: 10;
  }
`;

export const GranteeInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const GranteeActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: inherit;

  & .list-actions > button { 
    min-width: 120px;
  }
`;

export const InfoAlertContainer = styled.div`
  width: 100%;
  margin-bottom: 8px;
  padding: 12px 16px;
  background-color: ${(props) => props.theme.colors.lavender};
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightBlue};
`;

export const InfoAlertContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const InfoAlertTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

